import { API_AUTH } from "./common";

const downloadBlob = (data, headers, thuChiId) => {
  const blob = data instanceof Blob ? data : new Blob([data]);
  if (!blob.size) return;
  const contentDisposition = headers["content-disposition"] || "";
  let filename = `HoaDon_${thuChiId}.pdf`;
  const filenameMatch = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
    contentDisposition,
  );
  if (filenameMatch && filenameMatch[1]) {
    filename = filenameMatch[1].replace(/['"]/g, "");
  }
  const blobUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
};

const HoaDonApi = {
  xuatHoaDon: async (
    thuChiId,
    tienLai,
    tienPhi,
    isBanNhap,
    maSoThue,
    diaChi,
    phuongThucThanhToan,
    tyLePhiXuat,
    thueGTGT,
  ) => {
    const response = await API_AUTH.post(
      `hoa-don-viettel/xuat-hoa-don`,
      {
        ThuChiId: thuChiId,
        TienLai: tienLai,
        TienPhi: tienPhi,
        IsBanNhap: isBanNhap,
        MaSoThue: maSoThue,
        PhuongThucThanhToan: phuongThucThanhToan,
      },
      { responseType: "blob" },
    );
    const contentType = response.headers?.["content-type"] || "";
    if (contentType.includes("application/json")) {
      const text = await response.data.text();
      const parsed = JSON.parse(text);
      if (!response.ok)
        throw new Error(
          parsed.message || parsed.Message || "Lỗi khi xuất hóa đơn",
        );
      return parsed;
    }
    if (!response.ok)
      throw new Error(`Lỗi ${response.status} khi xuất hóa đơn`);
    downloadBlob(response.data, response.headers, thuChiId);
  },

  xuatNhieuHoaDon: (danhSach, isBanNhap) =>
    API_AUTH.post(`hoa-don-viettel/xuat-nhieu-hoa-don`, {
      IsBanNhap: isBanNhap,
      DanhSach: danhSach,
    }),

  huyHoaDon: (thuChiId, lyDoHuy) =>
    API_AUTH.post(`hoa-don-viettel/huy-hoa-don`, {
      ThuChiId: thuChiId,
      LyDoHuy: lyDoHuy,
    }),

  thayTheHoaDon: async (
    thuChiId,
    tienLai,
    tienPhi,
    maSoThue,
    diaChi,
    phuongThucThanhToan,
    tyLePhiXuat,
    thueGTGT,
  ) => {
    const response = await API_AUTH.post(
      `hoa-don-viettel/thay-the-hoa-don`,
      {
        ThuChiId: thuChiId,
        TienLai: tienLai,
        TienPhi: tienPhi,
        MaSoThue: maSoThue,
        DiaChi: diaChi,
        PhuongThucThanhToan: phuongThucThanhToan,
        TyLePhiXuat: tyLePhiXuat,
        ThueGTGT: thueGTGT,
      },
      { responseType: "blob" },
    );
    const contentType = response.headers?.["content-type"] || "";
    if (contentType.includes("application/json")) {
      const text = await response.data.text();
      const parsed = JSON.parse(text);
      if (!response.ok)
        throw new Error(
          parsed.message || parsed.Message || "Lỗi khi thay thế hóa đơn",
        );
      return parsed;
    }
    if (!response.ok)
      throw new Error(`Lỗi ${response.status} khi thay thế hóa đơn`);
    downloadBlob(response.data, response.headers, thuChiId);
  },

  linkInHoaDon: (thuChiId) =>
    API_AUTH.get(`hoa-don-viettel/link-in?thuchiId=${thuChiId}`),

  capNhatTrangThaiHoaDon: () =>
    API_AUTH.post(`hoa-don-viettel/cap-nhat-trang-thai`, {}),

  listXuatHoaDon: ({
    tuNgay,
    denNgay,
    ten,
    nhanvien,
    kieuvay,
    loaithuchi,
    tinhtrangno,
    kenhthanhtoan,
    trangThaiHoaDon,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `thu-chi-hop-dong/danh-sach-xuat-hoa-don?tungay=${tuNgay}&denngay=${denNgay}&ten=${ten}&nhanvien=${nhanvien}&kieuvay=${kieuvay}&loaithuchi=${loaithuchi}&tinhtrangno=${tinhtrangno}&kenhthanhtoan=${kenhthanhtoan}&trangThaiHoaDon=${trangThaiHoaDon}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {},
    ),
};

export default HoaDonApi;
